var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 226.893,
    height: 387.513,
    viewBox: "0 0 226.893 387.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_81",
    "data-name": "Gruppe 81",
    transform: "translate(226.893) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_23",
    "data-name": "Gruppe 23",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_28",
    "data-name": "Pfad 28",
    d: "M378.071,171.694,215.818,9.443a32.435,32.435,0,0,0-45.755,0L7.811,171.694a32.45,32.45,0,0,0,45.756,45.754L192.779,78.238,332.315,217.45a32.354,32.354,0,0,0,45.756-45.756Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightIcon);
export default __webpack_public_path__ + "static/media/ArrowRightIcon.dcbd270f31708a654ff5a3207ff9507b.svg";
export { ForwardRef as ReactComponent };